import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle.js";
import customSelectStyle from "assets/jss//material-dashboard-pro-react/customSelectStyle";
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles({ ...customInputStyle, ...customSelectStyle });

export default function CustomSelect(props) {
  const classes = useStyles();
  const {
    formControlProps,
    labelText,
    id,
    labelProps,
    selectProps,
    error,
    success,
    helperText,
    rtlActive,
    menuOptions = [],
  } = props;

  const underlineClasses = classNames({
    [classes.underlineError]: error,
    [classes.underlineSuccess]: success && !error,
    [classes.underline]: true,
  });

  const labelClasses = classNames({
    [" " + classes.labelRootError]: error,
    [" " + classes.labelRootSuccess]: success && !error,
    [classes.labelRTL]: rtlActive,
  });
  var formControlClasses;
  if (formControlProps !== undefined) {
    formControlClasses = classNames(
      formControlProps.className,
      classes.selectFormControl
    );
  } else {
    formControlClasses = classes.selectFormControl;
  }
  var helpTextClasses = classNames({
    [classes.labelRootError]: error,
    [classes.labelRootSuccess]: success && !error,
  });

  return (
    <>
      {menuOptions.length > 20 ?
        <FormControl {...formControlProps} style={{}}>
          <Autocomplete
            id={id}
            options={menuOptions}
            getOptionLabel={(option) => option?.label || ""}
            renderOption={(option, { selected }) => (
              <div
                selected={selected}
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <div>{option.label}</div>
                <div>
                  {option?.icon ?? ""}
                </div>
              </div>
            )}

            getOptionSelected={(option) => { return option?.value === selectProps?.value }}
            value={selectProps?.multiple ? (menuOptions.filter(o => selectProps?.value.includes(o.value))) : (menuOptions.length && menuOptions.find((o) => o.value == selectProps?.value))}
            onChange={(event, newValue, reason) => {
              const syntheticEvent = {
                target: {
                  name: selectProps?.name ?? id,
                  value: newValue ? (selectProps?.multiple ? newValue.map(v=>v.value): newValue.value) : "",
                },
              };
              //console.log("onChange", newValue, reason, syntheticEvent);
              if (newValue !== null) {
                selectProps.onChange(syntheticEvent);
              }
            }}
            classes={{ input: classes.select, inputRoot: classes.underline, option: classes.selectMenuItem }}
            //classes={{ option: classes.selectMenuItem }}
            renderInput={(params) => {
              const hasValue = selectProps?.multiple
                ? (params.inputProps.value && params.inputProps.value.length > 0)
                : !!selectProps?.value;
              //shrink: hasValue || params.InputLabelProps?.shrink,
              return (
                <TextField
                  {...params}
                  variant="standard"
                  label={labelText ?? ""}
                  InputLabelProps={{ className: classes.selectInputLabelRoot + " " + labelClasses, htmlFor: id, ...labelProps }}
                  helperText={helperText ?? ""}
                  FormHelperTextProps={{ id: id + "-text", className: helpTextClasses }}

                  className={formControlClasses}
                  error={!!error} //Need to work on this. Underline color is not set
                />)
            }}
            disabled={!!formControlProps?.disabled}
            multiple={selectProps?.multiple ?? false}
            renderTags={(selected) =>
              props.renderValue
                ? props.renderValue(selected)
                : (
                  <span className={classes.select} style={{ padding: 0 }}>
                    {selected.map((opt) => opt.label).join(", ")}
                  </span>
                )
            }
            disableClearable
          />
          {helperText && false &&  (
            <FormHelperText id={id + "-text"} className={helpTextClasses}>
              {helperText}
            </FormHelperText>
          )}
        </FormControl>
        :
        <FormControl {...formControlProps} className={formControlClasses}>
          {labelText !== undefined ? (
            <InputLabel
              className={classes.labelRoot + " " + labelClasses}
              htmlFor={id}
              {...labelProps}
            >
              {labelText}
            </InputLabel>
          ) : null}
          <Select
            MenuProps={{ className: classes.selectMenu }}
            classes={{ select: classes.select }}
            id={id}
            renderValue={selectProps?.multiple ? value => menuOptions.filter(e => value.includes(e.value)).map(e => e.label).join(", ") : null}
            {...selectProps}
          >
            {menuOptions.map((menu, index) => (
              <MenuItem
                {...menu}
                key={index}
                value={menu?.value}
                classes={{
                  root: classes.selectMenuItem,
                  selected: selectProps?.multiple ? classes.selectMenuItemSelectedMultiple : classes.selectMenuItemSelected
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>{menu.label}</div>
                  <div>{menu?.icon ?? ""}</div>
                </div>
              </MenuItem>
            ))}
          </Select>
          {helperText !== undefined ? (
            <FormHelperText id={id + "-text"} className={helpTextClasses}>
              {helperText}
            </FormHelperText>
          ) : null}
        </FormControl>
      }
    </>
  );
}

CustomSelect.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  white: PropTypes.bool,
  helperText: PropTypes.node,
  rtlActive: PropTypes.bool,
};
